import {
  DynamicComponentsConfigIdType,
  DynamicComponentsConfigParamType,
  DynamicComponentsType,
  MISSING_DYNAMIC_TEMPLATE_CONFIG_PER_PARAM_ERROR,
} from '#src/utils';

import { useDynamicTemplate } from '../DynamicTemplateProvider';

export const useDynamicComponentConfigParams = (
  dynamicComponentId: DynamicComponentsType
) => {
  const currentConfig = useDynamicTemplate();

  const getDynamicComponentParams = (
    dynamicComponentId: DynamicComponentsType
  ) => {
    return currentConfig.dynamicComponents[dynamicComponentId].params;
  };

  const getDynamicComponentConfigPerParam = ({
    paramId,
    configId,
  }: {
    configId: DynamicComponentsConfigIdType;
    paramId: DynamicComponentsConfigParamType;
  }): string | boolean => {
    const dynamicComponentParams =
      getDynamicComponentParams(dynamicComponentId);

    if (
      dynamicComponentParams[paramId] === undefined ||
      dynamicComponentParams[paramId][configId] === undefined
    ) {
      throw new Error(
        MISSING_DYNAMIC_TEMPLATE_CONFIG_PER_PARAM_ERROR(
          dynamicComponentId,
          paramId,
          configId
        )
      );
    }

    return dynamicComponentParams[paramId][configId];
  };

  return {
    getDynamicComponentConfigPerParam,
  };
};
